import {cdmMw} from '../api';

export default {
    api: cdmMw,
    url: '/api/dmm/display-books',
    useCache: true,
    parseResponse: ({data}) => data.map((data) => ({label: data, value: data})),
    defaultValue: []
};
